import { jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material';
import '../Utility/Normalize.js';
import '../Utility/SvgWrapper.js';
import { UnstyledList } from '../Utility/UnstyledList.js';
import { SIDEBAR_FOOTER_HEIGHT } from './Footer.js';
import { SIDEBAR_HEADER_HEIGHT } from './Header.js';

function Menu({ children, sx }) {
    return (jsx("nav", { "aria-label": "sidebar", children: jsx(List, { role: "tree", sx: sx, children: children }) }));
}
const List = styled(UnstyledList)(({ theme }) => ({
    position: "relative",
    padding: theme.spacing(2, 1),
    flexGrow: 1,
    overflowY: "auto",
    height: `calc(100vh - ${SIDEBAR_FOOTER_HEIGHT + SIDEBAR_HEADER_HEIGHT}px)`,
    "&::-webkit-scrollbar": {
        width: theme.spacing(1),
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: alpha(theme.palette.ui20, 0.6),
        borderRadius: theme.spacing(0.5),
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: alpha(theme.palette.ui20, 0.15),
        borderRadius: theme.spacing(0.5),
    },
    "& > li": {
        marginBottom: theme.spacing(1),
        li: {
            margin: theme.spacing(1, 0),
        },
    },
}));

export { Menu };
//# sourceMappingURL=Menu.js.map
